import BreadcrumbTrail, { type BreadcrumbItem } from './BreadcrumbTrail';

interface PageHeaderProps {
    title: string;
    /** Plain array of { label, to? } — write it directly in the page so routes stay obvious. */
    breadcrumbItems: BreadcrumbItem[];
    actions?: React.ReactNode;
    /** When false, outer wrapper is not sticky — use inside a parent sticky shell (e.g. audit details + tabs). Default true. */
    sticky?: boolean;
}

const PageHeader = ({ title, breadcrumbItems, actions, sticky = true }: PageHeaderProps) => (
    <div
        className={[
            'flex items-center justify-between p-3 md:p-4 2xl:p-5 bg-[var(--primary-canvas-color)]',
            sticky ? 'sticky top-0 z-20' : '',
        ]
            .filter(Boolean)
            .join(' ')}
    >
        <div>
            <h1 className="text-[16px] md:text-[18px] 2xl:text-[28px] font-semibold text-[var(--secondary-color)] leading-tight">
                {title}
            </h1>
            <BreadcrumbTrail items={breadcrumbItems} />
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
);

export default PageHeader;
export type { BreadcrumbItem } from './BreadcrumbTrail';

